import React from 'react';

const Delete = (props) => {
    const handleEditClick = () => {
        props.openDeleteRecord(props.data);
    };

    return (
        <div onClick={handleEditClick} title="Delete">
            <i className="fa fa-trash-o"></i> Delete
        </div>

    );
};

export default Delete;